<template>
  <div id="iframe-menu" style="height: 100%;">
    <iframe webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true"  :key="key" class="menu-iframe" :src="linkUrl" width="100%" height="100%" frameborder="0" id="innerIframe"></iframe>
  </div>
</template>
<script>
import {on, off} from '@/assets/utils'
import queryString from 'querystring'
export default {
  data () {
    return {
      key: Date.now(),
      linkUrl: ''
    }
  },
  created () {
    const linkUrlPath = localStorage.getItem('linkUrlPath') || getCookie('GEIPTOKEN')
    if(linkUrlPath){
      return
    }
    this.setLinkUrl()
  },
  mounted () {
    // 给window对象绑定message事件处理
    on(window, 'message', this.handMessage)
  },
  beforeDestroy () {
    off(window, 'message', this.handMessage)
  },
  methods: {
    // 1. 设置iframe地址
    setLinkUrl () {
      // if (this.$route.params && this.$route.params.name) {
      //   document.title = this.$route.params.name
      // }
      let linkUrl = decodeURIComponent(this.$route.params.linkUrl)
      const obj = {}
      if (this.$route.query) {
        for (const key in this.$route.query) {
          if (!(['linkUrl'].includes(key))) {
            obj[key] = this.$route.query[key]
          }
        }
      }
      let index = linkUrl.indexOf('?')
      if (index > -1) {
        // 2021.3.15 新增--开始
        // weburl中存在带#号，若有需要编码
        let queryParams = queryString.decode(linkUrl.substring(index + 1))
        if (queryParams.weburl && queryParams.weburl.indexOf('#') > -1) {
          linkUrl = `${linkUrl.substring(0, index)}?weburl=${encodeURIComponent(queryParams.weburl)}`
          delete queryParams.weburl
          for (let key in queryParams) {
            linkUrl += `&${key}=${queryParams[key]}`
          }
          // let weburl = `weburl=${encodeURIComponent(queryParams.weburl)}`
          // delete queryParams.weburl
          // linkUrl = `${linkUrl.substring(0, index)}?${weburl}&${queryString.stringify(queryParams)}`
        }
        // 2021.3.15 新增--结束
        linkUrl += '&'
      } else {
        linkUrl += '?'
      }
      linkUrl += queryString.stringify(obj)
      this.linkUrl = linkUrl
    }
  },
  watch: {
    $route () {
      if (this.$route.params) {
        const linkUrlPath = localStorage.getItem('linkUrlPath') || getCookie('GEIPTOKEN')
         if(linkUrlPath){
          return
        }
        this.key = Date.now()
        // this.linkUrl = decodeURIComponent(this.$route.params.linkUrl)
        this.setLinkUrl()
        this.setLeftMenus(this.$route)
      }
    }
  }
}
</script>
<style>
  @import '~@/views/iframe/Index.less';
</style>
